import React from "react";
import {
    Row,
    Col,
    Label
} from "reactstrap"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faFacebookF, 
    faLine, 
    faYoutube,
    faTiktok
} from "@fortawesome/free-brands-svg-icons";

const line_path = process.env.REACT_APP_LINE_PATH;

function FooterCustom(){
    

    return(
        <>
        <div className="footer">
            <div className="footer-section-2">
                <div className="footer-section-2-social">
                    <button className="btn-social mr-10" onClick={() => window.open('https://www.facebook.com/profile.php?id=100063635147660')}>
                        <FontAwesomeIcon icon={faFacebookF} className="icon" />
                    </button>
                    <button className="btn-social mr-10" onClick={() => window.open(line_path)}>
                        <FontAwesomeIcon icon={faLine} className="icon" />
                    </button>
                    <button className="btn-social mr-10" onClick={() => window.open('https://www.youtube.com/channel/UCDDllnPTvKVQS44xb0rlLBw')}>
                        <FontAwesomeIcon icon={faYoutube} className="icon" />
                    </button>
                    <button className="btn-social mr-10" onClick={() => window.open('https://www.tiktok.com/@taladteedin')}>
                        <FontAwesomeIcon icon={faTiktok} className="icon" />
                    </button>
                </div>
                <div>
                    <a href="/Privacy" target="_blank" className="foot-sec-text">นโยบาย</a>
                    © {new Date().getFullYear()}, Design By TaladTeedin.com Co., Ltd.
                </div>
            </div>
        </div>
        </>
    )
}
export default FooterCustom